var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInva2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_bi_12576_6455)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "#FFCA22",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 43H30.75M60.5 43H55.25M46.5 43H39.5",
    stroke: "#F7D132",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.125 30.75C33.4887 30.75 32.6715 30.75 32.0625 31.1018C31.6635 31.3321 31.3321 31.6635 31.1018 32.0625C30.75 32.6715 30.75 33.4887 30.75 35.125V50.875C30.75 52.5113 30.75 53.3285 31.1018 53.9375C31.3321 54.3365 31.6635 54.6679 32.0625 54.8982C32.6715 55.25 33.4887 55.25 35.125 55.25C36.7613 55.25 37.5785 55.25 38.1875 54.8982C38.5865 54.6679 38.9179 54.3365 39.1482 53.9375C39.5 53.3285 39.5 52.5113 39.5 50.875V35.125C39.5 33.4887 39.5 32.6715 39.1482 32.0625C38.9179 31.6635 38.5865 31.3321 38.1875 31.1018C37.5785 30.75 36.7613 30.75 35.125 30.75ZM50.875 34.25C49.2387 34.25 48.4215 34.25 47.8125 34.6018C47.4135 34.8321 47.0821 35.1635 46.8518 35.5625C46.5 36.1715 46.5 36.9887 46.5 38.625V47.375C46.5 49.0113 46.5 49.8285 46.8518 50.4375C47.0821 50.8365 47.4135 51.1679 47.8125 51.3982C48.4215 51.75 49.2387 51.75 50.875 51.75C52.5113 51.75 53.3285 51.75 53.9375 51.3982C54.3365 51.1679 54.6679 50.8365 54.8982 50.4375C55.25 49.8285 55.25 49.0113 55.25 47.375V38.625C55.25 36.9887 55.25 36.1715 54.8982 35.5625C54.6679 35.1635 54.3365 34.8321 53.9375 34.6018C53.3285 34.25 52.5113 34.25 50.875 34.25Z",
    stroke: "#F7D132",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_12576_6455",
    x: -14,
    y: -14,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12576_6455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_12576_6455",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.819608 0 0 0 0 0.196078 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_12576_6455"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInva2);
export default __webpack_public_path__ + "static/media/inva-2.f619fa99f9590864f7b8509c50b4b4de.svg";
export { ForwardRef as ReactComponent };